import { ResourcePage } from "./ResourcePage";

export function VirtualMachines() {
  return (
    <ResourcePage
      type="VirtualMachine"
      typeLabelSentence="virtual machine"
      typeLabelPlural="virtual machines"
      kindOptions={["Windows", "Linux"]}
      defaultPort={22}
    />
  );
}
